module.exports = __webpack_public_path__ + "static/media/chucai.15fb0252.png";